import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import { Favicon } from "../../ui/layout/favicon";

import type { IDomainSuggestion } from "./domain-input.types";

const FAVICON_CONTAINER_SIZE = 32;
const FAVICON_IMAGE_SIZE = 20;

interface IDomainOptionRowProps {
    suggestion: IDomainSuggestion;
    isSelected: boolean;
    onSelect: (domain: string) => void;
    dataAutomation: string;
}

export const DomainOptionRow = ({ suggestion, isSelected, onSelect, dataAutomation }: IDomainOptionRowProps) => {
    const { domain, iconUrl } = suggestion;

    return (
        <Combobox.Option
            id={domain}
            textValue={domain}
            isSelected={isSelected}
            onClick={() => onSelect(domain)}
            data-automation={`${dataAutomation}-option-${domain}`}
        >
            <Flex
                alignItems="center"
                gap="8px"
            >
                <Favicon
                    iconUrl={iconUrl || getFaviconUrl(domain, FAVICON_CONTAINER_SIZE)}
                    alt={domain}
                    size={FAVICON_CONTAINER_SIZE}
                    imageSize={FAVICON_IMAGE_SIZE}
                />
                <Combobox.OptionLabel>{domain}</Combobox.OptionLabel>
            </Flex>
        </Combobox.Option>
    );
};
